<template>
  <div class="home">
    <div class="job-category-top">
      <div class="blue-back">
        <div class="wrap blue-inner">
          <p class="job-category-title">Office Work</p>
          <h1 class="job-category-sub">事務の求人情報</h1>
        </div>
      </div>
      <div class="wrap">
        <img
          alt="事務トップ"
          src="@/assets/job-category/GH-kyujin-jimu001.webp"
          class="top"
        />
        <div class="text">
          <p>
            岐阜市でホームページ制作やウェブマーケティングを行っている株式会社グレイトヘルプの事務職は、家事と子育て、プライベートに忙しい主婦が中心となり、活躍しています。<br />出勤曜日が自由、勤務時間が自由時短勤務OKなど、時間的な自由度が非常に高い職場環境になっています。<br />事務職の経験があり、時間的な自由や働きやすさを求める人にピッタリなお仕事です。
          </p>
          <img src="@/assets/ezgif.com-gif-maker-A.png" alt="説明イラスト" />
        </div>
        <img
          src="@/assets/ezgif.com-gif-maker-B.png"
          alt="雲"
          class="illust-b"
        />
      </div>
    </div>

    <div class="recommendation">
      <HomeRecommendation />
    </div>

    <div class="space-top-70 space-top-130">
      <HomeWorkPlace />
    </div>

    <div class="space-top-130">
      <HomeWorkEnvironment />
    </div>

    <div class="space-top-130">
      <HomeWorkEnvironment2 />
    </div>

    <div class="space-top-130">
      <JobCategoryAboutWork
        :topImg="true"
        :middleImg="true"
        :imgPath1="'GH-kyujin-jimu002.webp'"
        :imgPath2="'GH-kyujin-jimu003.webp'"
        :subTitle="'事務のお仕事について'"
              :detail="'弊社の事務職は、パソコンに向き合った業務を主としたお仕事です。一般事務や雑務のお仕事の他、ホームページ制作や集客業務などを担当する専門職のサポート業務もあります。具体的には以下の仕事内容です。<br><br><span>一般事務作業</span><br>社内の一般事務業務です。マニュアルにそって遂行していく業務です。担当するお仕事のウエイトの50%程度です。<ul style=margin-top:20px;><li>勤怠の集計、給与の計算</li><li>請求書の発行</li><li>採用に際して発生する業務（入社手続き、入社準備、など）</li><li>各種手続き業務</li><li>売上や経費の明細のダウンロード業務</li><li>社内の消耗品の発注業務</li><li>不用品の回収業者の手配業務</li></ul><br><br><span>専門職のサポート業務全般</span><br>専門職のサポート業務です。マニュアルにそって遂行していく業務、または、上司から明確な指示があり、その指示どおりに遂行していく業務です。決まった仕事を決まったタイミングで繰り返ししていただく定例業務です。担当するお仕事のウエイトの40%程度です。必要となるのは、パソコンスキルと、業務内容を理解し、正確に遂行するスキルです。<ul style=margin-top:20px;><li>クライアントが執筆したブログの文章チェックとブログへの投稿</li><li>ホームページに掲載する文章の誤字脱字チェック</li><li>ホームページやECサイトの外観のチェック</li><li>ECサイトの商品の価格改定、在庫数の変更、クーポン発行業務</li><li>ホームページのカレンダーやお知らせ欄の更新</li><li>売上や新規集客数の集計業務</li><li>調査と調査結果の資料化（調査方法について明確な指示あり）</li></ul><br><br><span>雑務</span><br>パソコンと向き合わない業務です。担当するお仕事のウエイトの10%程度です。<ul style=margin-top:20px;><li>掃除</li><li>ゴミ出し</li><li>洗い物</li><li>電話対応</li><li>書類の整理業務</li></ul>'"
        :skill="'入社の段階で、パソコンの操作スキルは必須です。具体的には以下のスキルと経験です。<ul style=margin-top:20px;><li>1日の多くをパソコンと向き合う仕事の実務経験</li><li>ExcelやWordを業務で日常的に使用した実務経験</li></ul><br>高度なパソコンスキルが必要なわけではありません。パソコンを使った仕事に慣れていて、パソコン操作に抵抗がなく、仕事がこなせるスキルがあれば応募可能です。パソコンを使うことが主の事務の実務経験があればできる仕事です。<br>ExcelやWordについても高度なスキルが求められることはありません。Excelについては、カンタンな資料作成、調査結果をまとめるという業務が主です。関数やグラフの作成は業務で使うことがないので、これらのスキルは不問です。ExcelとWordを仕事で使った経験があれば問題ありません。<br><br>以下のような方は応募不可です。<ul><li>パソコンを使うことが主ではない事務（受付事務、雑務主体の事務、など）の経験者</li><li>パソコンを使った仕事に慣れていない</li><li>タイピングが遅い、タイピングに不安がある</li><li>ExcelやWordを使った仕事の経験が浅い</li></ul><br>パソコンスキルの他に、社内の上司やメンバーから依頼された内容を正確に理解し、遂行する力も必要になります。弊社のお仕事は、マニュアル、または、具体的な指示があり、それにそって遂行していくため、このスキルが必要です。<br>社内での立ち位置は、マーケティング部門、プログラミング部門、デザイン部門をサポートし、下から支える役割となります。そのため、人とのコミュニケーションを苦手とせず、周りに気を配りながら動くことができる人に合ったお仕事です。'"
        :experience="'弊社でのお仕事を通して、パソコンの操作スキルを高めることができます。このパソコンの操作スキルは、一生モノの財産となり、お子様に教えることや、ご自宅でパソコンを触るときにも活きます。<br>もちろん事務職として日々業務をしていただきますので、事務職としてのスキルと経験も高められます。'"
      />
    </div>

    <div class="space-top-130 space-top-70">
      <JobCategoryInfo
        :job="'事務'"
        :content="'一般事務、専門職のサポート業務全般（調査、媒体の更新業務、チェック業務、データ管理、など）、雑務'"
        :condition="'事務経験3年以上、パソコンの操作スキル、Excel・Wordの実務経験<br>※上記の「必要となる対応・能力・スキル」に詳細を記載'"
        :pay="'1,100円～1,350円<br>※「長期間、勤務していただきたい」という思いから、スタートの時給は1,100円で、勤務評価と勤務年数によって時給が上がる評価制度をとっています。'"
        :raise="'20円〜100円/時（社内の全職種による実績）'"
        :pg="false"
        :wdn="false"
        :isNonInsurableEmployment="true"
        :isStopRecruitment="true"
      />
    </div>
    <div class="space-top-130 space-top-70">
      <HomeSelectionSchedule />
    </div>

    <div class="space-top-130 space-top-70">
      <HomeQa :qaBoxList="qaBoxList" />
    </div>

    <div class="space-top-130 space-top-70">
      <HomeContact id="contact" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HomeRecommendation from "@/components/Home/Recommendation.vue";
import HomeWorkPlace from "@/components/Home/WorkPlace.vue";
import HomeWorkEnvironment from "@/components/Home/WorkEnvironment.vue";
import HomeWorkEnvironment2 from "@/components/Home/WorkEnvironment2.vue";
import JobCategoryAboutWork from "@/components/JobCategory/AboutWork.vue";
import JobCategoryInfo from "@/components/JobCategory/Info.vue";

import HomeSelectionSchedule from "@/components/Home/SelectionSchedule.vue";
import HomeQa from "@/components/Home/Qa.vue";
import HomeContact from "@/components/Home/Contact.vue";

export default {
  name: "Home",
  components: {
    HomeRecommendation,
    HomeWorkPlace,
    HomeWorkEnvironment,
    HomeWorkEnvironment2,
    JobCategoryAboutWork,
    JobCategoryInfo,
    HomeSelectionSchedule,
    HomeQa,
    HomeContact,
  },
  props: {},
  data() {
    return {
      qaBoxList: [
                {
          id: 1,
          qestion: "自由出勤の仕組みについて教えてください。自由に休めますか？",
          answer:
            "他の従業員と業務の進捗への影響がないことを前提にした勤務時間の自由となります。入社時に、1週間あたりの勤務時間（週15時間～）を決定します。この勤務時間において、出勤曜日と勤務時間が自由という仕組みです。出勤予定日にお休みをとった場合は、原則として1週間以内に欠勤分の勤務時間を補填する勤務をしていただいています（欠勤の理由と業務状況によっては補填なしの場合もあり）。お子様の長期休暇時は、事前の申請と調整によって、勤務日数・勤務時間を通常よりも減らすことは可能です。この条件を満たせる方のみご応募可能となっています。",
        },
        {
          id: 2,
          qestion: "業務中に車を運転することはありますか？",
          answer:
            "職種によってはあります。頻度はまれです。社有車があります。ご自身のお車を使う場合は手当を支給しています。業務中にお車の運転ができないことを前提とした応募も可能ですので、応募書類にその旨をご記載ください。",
        },
        {
          id: 3,
          qestion: "未経験でも応募可能でしょうか？",
          answer:
            "事務経験3年以上、パソコンの操作スキル、Excel・Wordの実務経験は必須です。詳細は、上記の「必要となる対応・能力・スキル」をご確認ください。なお、事務経験がない場合は、未経験で応募可能な職種としてマーケティングサポートと広告運用サポートがあります。",
        },
        {
          id: 4,
          qestion: "一般事務ではなく受付事務の経験のみでも応募可能でしょうか？",
          answer:
            "応募不可です。弊社の事務職は、パソコンに向き合ってする仕事が主で、お客様と接するようなコミュニケーションはほとんどありません。そのため、パソコンで仕事を行う一般事務の経験を必須としています。",
        },
        {
          id: 5,
          qestion: "副業・フリーランスでの応募も可能でしょうか？",
          answer:
            "平日9時30分～17時のご希望の曜日・時間帯で週15時間以上の勤務ができる場合は応募可能です。",
        },
        {
          id: 6,
          qestion: "在宅勤務・テレワークは可能でしょうか？",
          answer:
            "事務所への出社での勤務となっています。緊急事態宣言時などのみ行う場合があり、在宅勤務は原則としてございません。",
        },
        {
          id: 7,
          qestion: "グレイトヘルプに勤務しながら、副業は可能でしょうか？",
          answer:
            "可能です。ただし、弊社での勤務がメインであることを前提とします。また、弊社の事業内容と競合する仕事などは制限がある場合がございます。",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
  watch: {},
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.job-category-top {
  .blue-back {
    background-color: var(--main);
    .blue-inner {
      position: relative;
      padding-top: 100px;
      padding-bottom: 150px;
      @media screen and (max-width: 767px) {
        margin-top: 70px;
      }
      h1,
      p {
        color: white;
      }
    }
  }
  .top {
    margin-top: -120px;
  }
  .text {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 30px;
    @media screen and (max-width: 767px) {
      display: block;
    }
    p {
      width: 80%;
      margin-bottom: 30px;
      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
    img {
      width: 250px;
      @media screen and (max-width: 767px) {
        width: 200px;
        margin-left: calc(100% - 200px);
      }
    }
  }
  .illust-b {
    width: 200px;
    position: absolute;
    top: 60%;
    left: 15%;
    @media screen and (max-width: 1024px) {
      display: none;
    }
  }
}

.recommendation {
  background-color: var(--sub);
}
</style>